import {
  SelectionSummaryStyle,
  SummaryDividerStyle,
  SummaryLabelStyle,
  SummaryRowGroupStyle,
  SummaryRowStyle,
  SummaryValueStyle,
} from '../ContractIdSelectionModal.style';

interface SelectionSummaryProps {
  selectedCount: number;
  totalContractCount: number;
  selectedTaxIdCount: number;
  remainingTaxIds: number;
  taxIdLimit: number;
}

export function SelectionSummary({
  selectedCount,
  totalContractCount,
  selectedTaxIdCount,
  remainingTaxIds,
  taxIdLimit,
}: SelectionSummaryProps) {
  return (
    <SelectionSummaryStyle role="region" aria-live="polite" aria-label="Selection summary">
      <SummaryRowGroupStyle>
        <SummaryRowStyle>
          <SummaryLabelStyle>Selected Contracts</SummaryLabelStyle>
          <SummaryValueStyle>
            {selectedCount} / {totalContractCount}
          </SummaryValueStyle>
        </SummaryRowStyle>
        <SummaryDividerStyle />
        <SummaryRowStyle>
          <SummaryLabelStyle>Selected Tax IDs</SummaryLabelStyle>
          <SummaryValueStyle>
            {selectedTaxIdCount} / {taxIdLimit}
          </SummaryValueStyle>
        </SummaryRowStyle>
        <SummaryDividerStyle />
        <SummaryRowStyle>
          <SummaryLabelStyle>Remaining Tax IDs</SummaryLabelStyle>
          <SummaryValueStyle>{remainingTaxIds}</SummaryValueStyle>
        </SummaryRowStyle>
      </SummaryRowGroupStyle>
    </SelectionSummaryStyle>
  );
}
